import { useState, useContext } from "react";
import { useEffect } from "react"
import { useSearchParams } from 'react-router-dom';
import { Proof } from "./Proof";
import { AnnotationViewer } from "./AnnotationViewer";
import { Annotorious } from "@annotorious/react";
import { getAdRecord,getProofFiles } from "../services/apiService";
import { PageContext } from "./PageContext";
import { adRecord } from "../services/interfaces";
import React from "react";

class VieeProofEBoundary extends React.Component<{children: React.ReactNode}>{
    constructor(props: {children: React.ReactNode}){
        super(props);
        this.state={hasError:false}
    }

    static getDerivedStateFromError(error: Error){
        return {hasError:true}
    }
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.log(error);
        console.log(errorInfo.componentStack);
    }
    render(): React.ReactNode {
        return this.props.children;
    }
}
export default function ViewProof (){

    const [SearchParams] = useSearchParams();
    //const element = SearchParams.get('a')||"";
    const pageContext = useContext(PageContext);
    const slug = pageContext?.selectedAd.slug;
    const [authorized, setAuthorized]=useState(false);
    
    
    const setIsAuthorized=()=>{
            setAuthorized(true);
    }

    

    useEffect(()=>{
        const element = pageContext?.selectedAd.element;
        if (element && element!="" && slug && slug!=""){
            setIsAuthorized();
            getProofFiles(pageContext?.selectedAd.element, pageContext?.selectedAd.slug, pageContext?.selectedAd.tmpInt2,"","1",pageContext?.selectedAd.file1).then(data=>{
                console.log(data);
                pageContext?.setProofFiles(data);
            });
        }
    },[])

    return(
        authorized==true?
            <VieeProofEBoundary>
                <div className="mt-3" style={{height:"calc(vh - 120px", overflow:"scroll"}}>
                <h5>Read Only Proof for Ad: {pageContext?.selectedAd.slug}</h5>
                <Proof></Proof>
                </div>
            </VieeProofEBoundary>
        :
            <div className="mt-3" style={{height:"85vh"}}>
                <h5>Sorry. You are not authorized to view this proof.</h5>
            </div>
    )
}